import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './WhyRideWithUs.module.css';

function WhyRideWithUs() {
  const { t } = useTranslation();
  const cards = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
        </svg>
      ),
      titleKey: 'whyChooseUs.brandNew',
      subtitleKey: 'whyChooseUs.brandNewDesc',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      titleKey: 'whyChooseUs.lowDeposit',
      subtitleKey: 'whyChooseUs.lowDepositDesc',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      ),
      titleKey: 'whyChooseUs.noPassport',
      subtitleKey: 'whyChooseUs.noPassportDesc',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="1" y="3" width="15" height="13" />
          <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
          <circle cx="5.5" cy="18.5" r="2.5" />
          <circle cx="18.5" cy="18.5" r="2.5" />
        </svg>
      ),
      titleKey: 'whyChooseUs.freeDelivery',
      subtitleKey: 'whyChooseUs.freeDeliveryDesc',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
      ),
      titleKey: 'whyChooseUs.fastSupport',
      subtitleKey: 'whyChooseUs.fastSupportDesc',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="9" y1="15" x2="15" y2="15" />
          <line x1="12" y1="12" x2="12" y2="18" />
        </svg>
      ),
      titleKey: 'whyChooseUs.transparentPricing',
      subtitleKey: 'whyChooseUs.transparentPricingDesc',
    },
  ];

  return (
    <section id="why-choose-us" className={styles.section}>
      <h2 className={styles.heading}>{t('whyChooseUs.heading')}</h2>
      <p className={styles.subheading}>{t('whyChooseUs.subheading')}</p>
      <div className={styles.grid}>
        {cards.map((card, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.icon}>{card.icon}</div>
            <h3 className={styles.title}>{t(card.titleKey)}</h3>
            <p className={styles.subtitle}>{t(card.subtitleKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhyRideWithUs;
